export default __webpack_public_path__ + "media/images/work_with_us/team-pic-2-63e0878bde8d3da6bcab782d0ebf1329.webp";